import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users-user-new-role',
  templateUrl: './users-user-new-role.component.html',
  styleUrls: ['./users-user-new-role.component.scss']
})
export class UsersUserNewRoleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
